import { Outlet } from "react-router-dom";
import AppShell from "@/components/AppShell";

/**
 * GuestOrAuthShell — a shell that renders AppShell for BOTH authenticated
 * users and anonymous guests. Used only for the guest-accessible routes
 * (/feed and /w/:postId). AppShell already tolerates a null user via
 * `user?.` guards throughout, so guests see the same layout minus any
 * user-specific badges. Every gated navigation attempt or action fires
 * the SignupGate modal instead of navigating.
 *
 * Note: This does NOT use ProtectedRoute — guests must be allowed in.
 */
export default function GuestOrAuthShell() {
  return <AppShell />;
}
